import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';

import { Col } from 'antd';
import { Title, SubTitle, LastValidated, Info, Row } from 'ui';
import Spinner from 'common/spinner/components/spinner';
import ErrorHandler from 'common/error/components/error-handler';
import Contacts from 'common/contacts/components/contacts';
import ActionButtons from 'common/navigation/components/action-buttons';
import TicketButton from 'tickets/ticket-button';
import Payer from './payer';
import SoldTo from './sold-to';

const CustomerInfo = ({
  getCustomerInfoRequest,
  id,
  customer,
  payer,
  error,
  isLoading,
  renderMenu,
  intl,
}) => {
  useEffect(() => {
    getCustomerInfoRequest({ id });
  }, []);

  return <>
    {renderMenu(
      <ActionButtons>
        <TicketButton id={id} />
      </ActionButtons>,
    )}
    {isLoading ?
      <Spinner title={intl.formatMessage({ id: 'common.LOADING_INFO' })} />
      :
      <Info>
        <Form layout='vertical'>
          <ErrorHandler type='notification' error={error} />
          <Row>
            <Col span={24}>
              <Title>{customer.name}</Title>
            </Col>
          </Row>
          <Row type='flex' gutter={25} marginBottom={45}>
            <Col sm={24} xs={24} data-test-id='sold-to'>
              <SubTitle>
                sold-to <LastValidated date={customer.lastValidated} />
              </SubTitle>
              <SoldTo data={customer} />
            </Col>
          </Row>
          <Row type='flex' gutter={25}>
            <Col sm={12} xs={24} data-test-id='payer'>
              <SubTitle>payer</SubTitle>
              <Payer data={payer} />
            </Col>
            {customer.contactPeople && customer.contactPeople.length ?
              <Col sm={12} xs={24} data-test-id='contacts'>
                <SubTitle>contacts</SubTitle>
                <Contacts contacts={customer.contactPeople} />
              </Col>
              : ''
            }
          </Row>
        </Form>
      </Info>
    }
  </>;
};

CustomerInfo.propTypes = {
  getCustomerInfoRequest: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  customer: PropTypes.object,
  payer: PropTypes.object,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  renderMenu: PropTypes.func.isRequired,
  intl: PropTypes.object,
};

export default compose(
  injectIntl,
)(CustomerInfo);
